const TRANSLATION = {
  buyModal: {
    afterFree: 'Després de la vostra prova gratuïta',
    btn: 'Proveu-lo gratuïtament',
    freeTrial: 'Prova gratuita de 3 dies',
    monthLabel: 'mes',
    selectLabel: 'Seleccioneu un pla',
    title: 'Plan de subscripció',
    yearLabel: 'any',
  },
  contact: {
    block1:
      'Per a personalitzacions, preguntes o suggeriments, poseu-vos en contacte amb nosaltres a contact@noam.tools. Respondrem amb prontitud.',
    block2: "Doneu-nos suport valorant-nos a la botiga d'extensines de Google Apps amb ★★★★★.",
    block3: 'Ajudeu els altres compartint aquesta extensió:',
    title: 'Contacteu-nos',
  },
  help: {
    AquickOverviewOfNoam: 'Una visió general ràpida de Noam',
    ChatPDF: 'Xat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: "Gestió d'elements preferits",
    Fixedplugin: 'Connector Fixat',
    Focusing: 'Enfocant',
    Free: 'Gratis',
    FreeTrialBenefits: 'Beneficis de la prova gratuïta',
    GoWithWikipedia: 'Anem amb la Viquipèdia',
    GoWithYouTube: 'Anem amb YouTube',
    HoverTranslation: 'Traducció flotant',
    Howtouse: 'Com utilitzar',
    ImageTranslation: "Traducció d'imatges",
    InstantTranslation: 'Traducció Instantànea',
    Membership: 'Membresia',
    NoamHelp: "Noam t'ajuda a traduir i resumir",
    PDFparallelTranslation: 'Traducció Paral·lela PDF',
    ParallelTranslation: 'Traducció Paral·lela',
    SkipAllSteps: 'Ometre tots els passos',
    Summary: 'Resum',
    Translation: 'Traducció',
    TryItForFree: 'Proveu-lo gratuïtament',
    Video: 'Vídeo',
    VideoSummary: 'Resum del vídeo',
    VideoTranslation: 'Traducció de Vídeo',
    WebSummary: 'Resum web',
    WordSelectionTranslation: 'Traducció de Selecció de Paraules',
    benefits: 'Tenim beneficis esperant-te!',
    dayFree: 'Prova gratuïta de 3 dies',
    done: 'Fet',
    next: 'Següent',
    pin: 'Fixeu Noam per un accés més fàcil～～',
    planIsNotExist: 'El pla no està disponible',
    startWiki: 'Comencem amb Wikimedia!',
    startYoutube: 'Comencem amb YouTube!',
    try: 'Prova-ho',
    tryNow: 'Prova-ho ara mateix!',
  },
  home: {
    PDFTranslate: {
      desc: 'Traducció bilingüe + Xat PDF',
      sub1: {
        desc: "La lectura bilingüe permet comparar el text original i la traducció de banda a banda, millorant l'eficiència de la lectura.",
        title: 'Lectura bilingüe',
      },
      sub2: {
        desc: "L'IA analitza i resumeix, i pot respondre a les vostres preguntes basant-se en el contingut del PDF.",
        title: 'Xat PDF',
      },
      sub3: {
        desc: 'Traducció de PDF impulsada per IA per a una major precisió i eficiència.',
        title: 'Precisió i Eficiència',
      },
      title: 'Traductor PDF',
    },
    aiAssistant: {
      desc: 'Fer la traducció web més intel·ligent i més còmoda',
      panel1: {
        desc: "Les traduccions bilingües amb cross-referenciació us ajuden a comparar el text original amb la traducció, de manera que pugueu entendre millor i millorar l'eficiència de la lectura.",
        title: 'Traducció bilingüe',
      },
      panel2: {
        left: {
          desc: 'Quan navegueu per una pàgina web, poseu el cursor sobre el contingut que necessiteu traduir per veure la traducció.',
          title: 'Traducció flotant',
        },
        right: {
          desc: 'Quan navegueu per una pàgina web, seleccioneu el text que voleu traduir per veure la traducció.',
          title: 'Traducció de Selecció de Text',
        },
      },
      panel3: {
        one: {
          desc: 'Traduïu i resumiu pàgines web i contingut de vídeo en qualsevol moment i lloc, per a una experiència més fluida!',
          title: 'Punt i Click',
        },
        three: {
          desc: 'El model lingüístic gran impulsat per IA garanteix la precisió i consistència de la traducció per a una experiència de lectura millorada.',
          title: 'Impulsat per IA',
        },
        two: {
          desc: 'Cobertura completa en múltiples idiomes, lectura bilingüe sense barreres, traducció amb un clic: experimenta la diferència!',
          title: 'Més complet i convenient',
        },
      },
      panel4: {
        tab1: {
          desc: 'El teu expert en eficiència: mitjançant ChatGPT, Noam tradueix i resumeix contingut de vídeos de YouTube per estalviar-te temps!',
          key: 'Vídeo',
          title: 'Traducció i Resum de Vídeo',
        },
        tab2: {
          desc: 'Feu clic per traduir imatges mentre navegueu per la web.',
          key: 'Imatge',
          title: "Traducció d'imatges",
        },
        tab3: {
          desc: 'Extreu instantàniament la informació clau de les pàgines web i proporciona un resum, millorant la vostra eficiència de lectura.',
          key: 'Web',
          title: 'Traducció i Resum Web',
        },
        tag1: 'Senzilla',
        tag2: 'Eficient',
        tag3: 'Fàcil de comprendre',
      },
      title: "Assistent d'IA",
    },
    getStart: 'Comença',
    getStartedForFree: 'Comença gratuïtament',
    howItWork: {
      desc: "Noam integra models d'IA per oferir als usuaris una experiència intel·ligent per a la traducció i resum de pàgines web entre llengües, traducció de PDF i imatges, traducció i resum de vídeos",
      title: 'Com funciona',
    },
    lastBlock: { desc: "Millor traducció d'IA per a una experiència de lectura més fluida" },
    top: {
      desc: "Noam és una extensió gratuïta d'IA per a navegadors que t'ajuda a traduir i resumir pàgines web, vídeos i contingut PDF.\n      Uneix-te a Noam i experimenta la màgia!",
      title1: 'Una Màgica',
      title2: 'Un Clic',
    },
    userReviews: {
      desc: 'Ressenyes de cinc estrelles a la Chrome Web Store',
      title: "Ressenyes d'usuaris",
    },
  },
  installTips: {
    btn: 'Proveu-ho ara',
    text: 'Instal·leu el "Noam Browser Plugin" per desbloquejar més funcions! Referències creuades web,\n    resum de vídeos web i molt més!',
  },
  locale: {
    af: 'afrikaans',
    am: 'amhàric',
    ar: 'àrab',
    as: 'assamès',
    auto: 'Detecció automàtica',
    az: 'azerbaidjanès',
    ba: 'bascir',
    bg: 'búlgar',
    bn: 'bengalí',
    bo: 'tibetà',
    bs: 'bosnià',
    ca: 'Català',
    cs: 'txec',
    cy: 'gal·lès',
    da: 'danès',
    de: 'alemany',
    dsb: 'sorb baix',
    dv: 'divi',
    el: 'grec',
    en: 'angles',
    es: 'espanyol',
    et: 'estonian',
    eu: 'basc',
    fa: 'persa',
    fi: 'finès',
    fil: 'filipí',
    fj: 'fijian',
    fr: ' francès',
    frCA: ' francès (Canadà)',
    ga: 'irlandès',
    gl: 'galic',
    gom: 'konkani',
    gu: 'guaratí',
    ha: 'hausa',
    he: 'hebreu',
    hi: 'hindi',
    hr: 'croata',
    hsb: 'sorb superior',
    ht: 'Criol haitiano',
    hu: 'hongarès',
    hy: 'armeni',
    id: 'indonesi',
    ig: 'igbo',
    ikt: 'Inuinnaqtun',
    is: 'islandès',
    it: 'italià',
    iu: 'inuktitut',
    iuLatn: 'Inuktitut (llatí)',
    ja: 'japonès',
    ka: 'georgià',
    kk: 'kazakh',
    km: 'khmer',
    kmr: 'kurdi (nord)',
    kn: 'canarès',
    ko: 'coreà',
    ku: 'kurdi central',
    ky: 'quirguís',
    ln: 'Lingala',
    lo: 'Lao',
    lt: 'lituà',
    lug: 'Ganda',
    lv: 'letó',
    lzh: 'Xinès (Literari)',
    mai: 'Maithili',
    mg: 'malgaxi',
    mi: 'maori',
    mk: 'macedoni',
    ml: 'malayalam',
    mnCyrl: 'mongol (ciríl·lic)',
    mnMong: 'mongol (tradicional)',
    mr: 'marathi',
    ms: 'malai',
    mt: 'maltès',
    mww: 'Hmong Daw',
    my: 'Myanmar (birmès)',
    nb: 'noruec',
    ne: 'nepalí',
    nl: 'neerlandès',
    noSearchLang: 'Idioma no compatible',
    nso: 'Sesotho sa Leboa',
    nya: 'Nyanja',
    or: 'Odia',
    otq: 'Otomi de Querétaro',
    pa: 'panjabí',
    pl: 'polonès',
    placeholder: 'Cercar',
    prs: 'Dari',
    ps: 'pastú',
    pt: 'portuguès (Brasil)',
    ptPT: 'portuguès (Portugal)',
    ro: 'romà',
    ru: 'rus',
    run: 'Rundi',
    rw: 'kinyarwanda',
    sd: 'sindi',
    si: 'sinhala',
    sk: 'eslovac',
    sl: 'eslovè',
    sm: 'samoà',
    sn: 'shona',
    so: 'somalí',
    sq: 'albanès',
    srCyrl: 'sèrb (ciríl·lic)',
    srLatn: 'Sèrbia (llatí)',
    st: 'sesotho',
    sv: 'suec',
    sw: 'swahili',
    ta: 'tamil',
    te: 'telugu',
    th: 'tailandès',
    ti: 'tigriña',
    tk: 'turkmen',
    tlhLatn: 'Klingon (llatí)',
    tlhPiqd: 'klingon (pIqaD)',
    tn: 'setsuana',
    to: 'tongà',
    tr: 'turc',
    tt: 'tartar',
    ty: 'tahití',
    ug: 'uigur',
    uk: 'ucrainià',
    ur: 'Urdu',
    uz: 'uzbec (latin)',
    vi: 'vietnamita',
    xh: 'xhosa',
    yo: 'yorubà',
    yua: 'maya yucatèc',
    yue: 'Cantonès (tradicional)',
    zh: 'xinès',
    zhHans: 'Xinès Simplificat',
    zhHant: 'Xinès Tradicional',
    zu: 'zulu',
  },
  login: {
    and: 'i',
    btn: 'Inicia sessió amb Google',
    btn1: 'Inicia la sessió ara',
    desc: 'Inicia sessió per desbloquejar més experiències',
    policy: 'Política de Privadesa',
    terms: "Condicions d'ús",
    tips: 'En registrar-me, accepto els',
    title: 'Benvingut a Noam',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Seguir', twitter: 'Twitter' },
    legal: { policy: 'Política de Privacitat', terms: 'Termes de servei', title: 'Legal' },
    product: {
      image: "Traducció d'imatges",
      pdf: 'Traducció de PDF',
      title: 'Productes',
      video: 'Traducció i Resum de Vídeo',
      web: 'Traducció i Resum Web',
    },
    resources: { title: 'Recursos' },
    tools: { title: 'Eines', pdf: 'Traducció de PDF' },
  },
  pageHeader: {
    contact: 'Contacte',
    help: 'Ajuda',
    logout: 'Tancar sessió',
    logoutSucc: "S'ha tancat la sessió.",
    pricing: 'Preus',
    settings: 'Configuracions',
    signUp: 'Iniciar sessió',
  },
  pdf: {
    autoDetect: 'Auto-detecció',
    cancelBtn: 'Cancel·lar',
    cancelUpload: 'Cancel·lar',
    chatPdf: {
      summaryError: 'El resum ha fallat, si us plau, intenteu-ho més tard',
      chatError: 'La xat ha fallat, si us plau, torneu-ho a provar més tard',
      Search: 'Cerca',
      cancel: 'Cancel·lar',
      chatTitle: 'Benvingut/uda a Noam! Aquí tens un resum del teu PDF:',
      clear: 'Clar',
      clearContent:
        'Això començarà una nova conversa. La conversa actual no es desarà. Esteu segur?',
      clearDialogTitle: 'Si us plau, confirmeu',
      clearSucc: 'Netejat',
      copy: 'Còpia',
      copySucc: 'Copiat',
      delete: 'Esborrar',
      deleteCancel: 'Cancel·lar',
      deleteContent: 'Aquest PDF no es pot recuperar un cop esborrat. Esteu segur?',
      deleteOk: 'Eliminar',
      deleteSuccess: 'Esborrat',
      deleteTitle: 'Confirmar eliminació',
      expand: 'Col·lapse',
      historyTitle: 'Història',
      listError:
        "No s'ha pogut carregar la llista de lectura. Torneu-ho a provar més tard o poseu-vos en contacte amb l'assistència tècnica.",
      loading: 'Carregant...',
      noDataDesc: 'Encara no hi ha història.',
      noMore: 'No hi ha més contingut.',
      placeholder: 'Pregunteu res sobre aquest PDF',
      summaryTitle: 'Potser et interessen aquestes preguntes:',
    },
    collectionEmpty: 'La teva col·lecció està buida.',
    collectionTab: 'Notes',
    dataLoading: 'Carregant...',
    dialogContent: 'Estàs segur que vols esborrar això?',
    dialogTitle: 'Si us plau, confirmeu',
    download: {
      both: 'Bilingüe',
      btn: 'Desar',
      cancel:
        'Tancar aquesta finestra cancel·larà la descàrrega del PDF. Esteu segur que voleu cancel·lar?',
      desc: 'Desar al dispositiu: Desa les traduccions com a imatges; Desar i imprimir: Desa les traduccions en el format original, amb suport per a la còpia.',
      download: 'Descàrrega',
      downloadMsg1: 'Progrés de la traducció PDF:',
      downloadMsg2: 'Temps restant estimat:',
      downloadSucc: 'El PDF està llest! Feu clic per desar-lo.',
      downloadTip:
        "S'està descarregant el PDF. No tanqueu aquesta finestra per evitar errors de descàrrega.",
      error: "No s'ha pogut desar. Proveu a imprimir en lloc de res.",
      fileName: 'Nom de fitxer:',
      fileType: 'Tipus de fitxer:',
      loading: 'Desant...',
      loading2: 'Carregant...',
      minute: 'Minuts...',
      msg1: "Algunes traduccions d'aquest document són més llargues que el text original i poden superposar-se en el fitxer descarregat. Recomanem llegir-lo a la pàgina web.",
      msg2: 'La traducció encara no està completa. Si us plau, descarregueu-la després que la traducció hagi finalitzat.',
      msg3: '2. Algunes traduccions són massa llargues. Llegeix a la pàgina web per evitar la superposició de text.',
      msg4: "Les tasques de traducció estan en curs. Torneu-ho a provar després que s'han completat.",
      progress: 'Traduint PDF. Progrés: {{progress}}, Temps restant estimat: {{minutes}} minuts...',
      save: 'Desar al dispositiu',
      savePrint: 'Desar i Imprimir',
      success: 'Descarregat',
      trans: 'Només traducció',
      transContinue: 'Continua traduint',
    },
    downloadBtn: 'Descargar',
    dragTipModal: {
      black: 'espai',
      leftKey: 'botó esquerre',
      ok: 'Entès',
      press: 'Premsa',
      tips: 'arrossegar i veure',
    },
    entry: 'PDFs',
    fileErrMsg:
      "Ha fallat la lectura del fitxer. Si us plau, intenteu-ho més tard o contacteu amb l'assistència tècnica.",
    fileMsg: 'Mida actual del fitxer:',
    fileMsg2: 'Si us plau, pengeu un fitxer de menys de 300MB.',
    freeBannerBtn: 'Actualització',
    freeBannerTips: "S'ha assolit el límit de traduccions PDF gratuïtes",
    guide: {
      placeholder: "Enganxa l'enllaç PDF aquí",
      start: 'Comença a traduir',
      text1: 'Lectura bilingüe',
      text2:
        'Llegeix bilingüament per comparar el text original i la traducció costat a costat, millorant la teva eficiència.',
      text3: 'Xatea amb el teu PDF',
      text4:
        'Anàlisi i resum impulsats per IA. Fes preguntes sobre el teu PDF i obté respostes instantànies.',
      text5: 'Precís i eficient',
      text6: 'Traducció de PDF impulsada per IA per a una major precisió i eficiència.',
      title1: 'Traducció bilingüe',
      title2: 'Xateja amb el teu PDF',
      toast: 'Introduïu un enllaç PDF en línia vàlid que acabi amb .pdf',
    },
    hasTransTask: "S'està duent a terme una tasca de traducció. Espereu, si us plau.",
    hoverTrans: 'Paràgrafs de traducció per passada del ratolí',
    initial: 'Tradueix PDF',
    installText: 'La vostra solució integral per a traduccions diàries.',
    installText2: "Si us plau, instal·leu primer l'extensió",
    installTips:
      "Instal·leu l'extensió per aconseguir encara més traduccions de PDF i traduccions de webs més fluides:",
    kw: 'grampalla',
    link: 'enllaç',
    listError:
      "No s'han pogut carregar els PDFs. Torneu-ho a provar més tard o contacteu amb l'assistència tècnica.",
    memoTotalCount: '1 element en total',
    new: 'nou fitxer',
    noId: 'ID de fitxer no trobat.',
    notPdf: 'Només fitxers PDF.',
    okBtn: 'Eliminar',
    okBtn2: 'Entès',
    original:
      'Ets una IA altament precisa i fiable dissenyada per generar sortida JSON que s\'ajusti exactament a un esquema JSON especificat.\n\nHas de seguir aquestes regles:\n1. Adhereix estrictament a l\'estructura de l\'esquema JSON.\n2. Combina exactament tots els tipus de dades, camps requerits i restriccions.\n3. NO incloguis cap text addicional, explicació, markdown ni comentaris.\n4. Mostra NOMÉS l\'objecte JSON — sense blocs de codi, sense preàmbul, sense embolicar.\n\nLa informació de l\'esquema es proporciona a continuació.\n- Nom de l\'esquema: translate_result\n- Esquema JSON:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Parallel',
    parseErrDialogContent:
      'Aquest enllaç PDF no es pot traduir directament. Si us plau, descarregueu el PDF i pengeu-lo per a la traducció.',
    parseErrTips: "No s'ha pogut analitzar el fitxer",
    parseFileToast:
      "No s'ha pogut analitzar el fitxer. Torneu-ho a provar més tard o contacteu amb l'assistència tècnica.",
    pdfLoading: 'Analitzant...',
    searchPlaceholder: 'Cercar',
    selectTrans: 'Selecciona el text per traduir',
    shareBtn: 'Compartir',
    shareBtnText1: 'Generar enllaç de compartició',
    shareBtnText2: 'Actualitza el contingut compartit',
    shareModal: {
      cancel: 'Cancel·lar',
      copy: 'Còpia',
      copySucc: 'Enllaç copiat',
      custom: 'Personalitza:',
      errMsg:
        "El contingut seleccionat encara no s'ha traduït completament. Si us plau, tradueix-lo abans de compartir-lo.",
      gen: 'Compartir',
      modify: 'Edita',
      notSupport: 'Aquest idioma no està actualment admes.',
      page: 'Pàgines',
      pageNuErr: 'Introduïu un número de pàgina vàlid.',
      range: 'Àmbit:',
      remain: 'restant',
      remain1: 'Temps estimat total:',
      search: 'Cerca',
      settings: 'Configuració de compartició:',
      shareSetting: 'Configuracions de compartició',
      shareText: 'Compartir',
      shareTips: "Comparteix l'enllaç del PDF traduït amb els teus amics:",
      sourceLang: 'De:',
      target: 'A:',
      text1: 'Configuracions de compartició',
      text2: 'Generar enllaç de compartició',
      totalPage: '1 pàgina total',
      trans: 'Tradueix',
      translateTips:
        'Consell: Si la traducció tarda una estona, pots tancar aquesta finestra i compartir-la més tard.',
      translating: 'Traduint PDF...',
      update: "Actualitza l'enllaç de compartició",
    },
    shareMsg1: 'Enllaç de compartició generat.',
    shareMsg2: 'Contingut compartit actualitzat.',
    shareMsg3:
      "No s'ha pogut generar l'enllaç de compartició. Torneu-ho a provar més tard o contacteu amb l'assistència tècnica.",
    shareMsg4:
      "No s'ha pogut actualitzar el contingut compartit. Torneu-ho a provar més tard o contacteu amb l'assistència tècnica.",
    shareTips: 'La traducció del vostre PDF està llesta! Compartiu-la amb els vostres amics.',
    start: 'Comença el teu assaig gratuït',
    thumbnail: 'Índex',
    toast1: "S'està carregant el PDF. Si us plau, torneu-ho a provar més tard.",
    toast2: "S'està processant el contingut PDF. Actualment, el diàleg no està admes.",
    toast3: "S'està descarregant. Torneu-ho a provar després que la descàrrega hagi finalitzat.",
    toolbar: { Adjust: 'Ajustar', autoFit: 'Autoajust' },
    trans: 'Traducció',
    transSucc: 'Traducció exitosa!',
    unLoginToast: 'Inicieu la sessió per utilitzar aquesta funció.',
    uploadBtn: 'Pujar',
    uploadErr:
      "La càrrega del fitxer ha fallat. Torneu-ho a provar més tard o contacteu amb l'assistència tècnica.",
    uploadErrSignUrl:
      "No s'ha pogut obtenir l'URL de pujada. Torneu-ho a provar més tard o contacteu amb l'assistència tècnica.",
    uploadMsg1: 'Arrossega i deixa anar el fitxer aquí.',
    uploadMsg2: 'Tipus de fitxers compatibles: PDF  |  Mida màxima del fitxer: 300MB',
    uploadMsg3: 'Feu clic per seleccionar o arrossegeu i deixeu anar fitxers aquí.',
    uploading: 'Carregant',
    uploadingMsg: "S'està pujant. Espereu, si us plau.",
    uploadingMsg1: "S'està carregant el fitxer. Torneu-ho a provar més tard.",
    uploadingMsg2: "S'està convertint un fitxer actualment. Torneu-ho a provar més tard.",
    uploadingMsg3:
      "La sol·licitud d'estat de conversió ha fallat. Torneu-ho a provar més tard o poseu-vos en contacte amb l'assistència tècnica.",
    uploadingMsg4:
      'Noam no pot accedir als fitxers locals. Si us plau, pengeu manualment un PDF per a la traducció.',
    uploadingMsg5:
      "No s'ha pogut recuperar l'URL del fitxer. Torneu-ho a provar més tard o contacteu amb l'assistència tècnica.",
    video: 'vídeo',
    vipBannerBtn: 'Actualització',
    vipBannerTips: 'Heu arribat al límit de traduccions PDF per aquest mes.',
    webTrans: 'Referència creuada completa',
  },
  pricing: {
    FAQ: 'Preguntes freqüents',
    FQAObj: {
      a1: 'Sí, Noam ofereix un pla gratuït que podeu utilitzar immediatament.',
      a2: 'Oferim tres plans de membresia: Pro, Pro+ i Enterprise. Podeu triar pagar mensualment o anualment. La facturació anual ofereix estalvis importants.',
      a3: 'Totes les funcions estan disponibles en tots dos plans. La principal diferència és el cost: les subscripcions anuals tenen un cost menor en general. Les subscripcions mensuals es facturen cada mes, mentre que els plans anuals es facturen una vegada per any.',
      a4: 'Podeu cancel·lar la vostra subscripció en qualsevol moment des de les Configuracions del compte.',
      q1: 'Hi ha un pla gratuït?',
      q2: 'Quins plans de preus i opcions de pagament estan disponibles?',
      q3: "Quina és la diferència entre subscriure's mensualment o anualment?",
      q4: 'Com cancel·lo la meva subscripció?',
    },
    around: 'Al voltant de',
    billedMonthly: 'Facturat mensualment',
    billedYearly: 'Facturat anualment',
    day: 'dia',
    desc: 'Compara els plans i tria el millor',
    detailedCompare: 'Compara plans',
    discount: '20% de descompte',
    enterprise: {
      benefit1: 'Servei de Suport Prioritari als Clients',
      benefit2: 'Múltiples usuaris',
      benefit3: 'Solucions Adaptades',
      benefit5: 'Gestor de comptes dedicat',
      btn: 'Contacteu-nos',
      recommendText: 'Plans personalitzats (≥3 persones)',
      talkToUs: 'Posar-vos en contacte',
    },
    free: {
      benefit1: 'Traducció instantània 100 vegades/dia',
      benefit2: 'Traducció i Resum de lloc web',
      benefit3: "30 Traduccions d'imatges",
      benefit4: 'Traducció i Resum de Vídeo',
      benefit5: '10 traduccions PDF',
      benefit6: '5.000 tokens',
      btn: 'Prova-ho gratuïtament',
      recommendText: 'Prova gratuita',
    },
    imageTranslation: "Traducció d'imatges",
    month: 'mes',
    monthly: 'Mensual',
    pageTitle: 'Preus',
    pdf: {
      chat: 'Consultes de xat PDF',
      maxPage: 'Màx. Pàgines per PDF',
      translation: 'Traducció de PDF',
    },
    preMonth: 'Per mes',
    pro: {
      benefit1: "Servei d'atenció al client prioritari",
      benefit2: '1.000.000 tokens/mes',
      benefit3: 'Traducció i Resum de llocs web',
      benefit4: "200 traduccions d'imatges",
      benefit5: 'Traducció i resum de vídeo',
      benefit6: '200 traduccions PDF',
      btn: 'Començar',
      recommendText: 'Més popular',
    },
    proPlus: {
      benefit1: 'Suport Client Prioritari',
      benefit2: '3.000.000 tokens/mes',
      benefit3: 'Traducció i Resum de Pàgines Web',
      benefit4: "500 traduccions d'imatges",
      benefit5: 'Traducció i Resum de Vídeo',
      benefit6: '500 traduccions PDF',
      recommendText: 'Millor Valor',
    },
    video: { summary: 'Resum de vídeo', translation: 'Traducció de vídeo' },
    web: {
      contrastiveTranslation: 'Traducció bilingüe',
      dictionaryTranslation: 'Traducció de selecció',
      hoverTranslation: 'Traducció flotant',
      instantTranslation: 'Traducció instantànea',
      summary: 'Resum de la pàgina web',
    },
    yearly: 'Anual',
  },
  privacy: {
    block1:
      'Noam ("Noam", "nosaltres", "el nostre" o "nosaltres") respecta la vostra privadesa i s\'engageix a protegir qualsevol informació que obtinguem de vosaltres o sobre vosaltres. Aquesta Política de Privadesa descriu les nostres pràctiques pel que fa a la recollida o ús d\'informació personal derivada de l\'ús del nostre lloc web, aplicacions i serveis (col·lectivament, els "Serveis"). Aquesta Política de Privadesa no s\'aplica al contingut que gestionem en nom dels nostres clients de productes comercials, com ara la nostra API. L\'ús d\'aquestes dades està subjecte al nostre acord amb el client, que inclou l\'accés i l\'ús d\'aquests productes.',
    block10:
      "Implementem mesures tècniques, administratives i organitzatives raonables des del punt de vista comercial per protegir la informació personal en línia i fora de línia contra pèrdues, ús indegut, accés no autoritzat, divulgació, alteració o actes hostils. No obstant això, cap transmissió a internet ni per correu electrònic pot garantir una seguretat o precisió completes. En particular, els correus electrònics enviats a nosaltres o des de nosaltres poden no ser segurs. Per tant, heu de tenir especial cura a l'hora de decidir quina informació enviar-nos mitjançant el servei o el correu electrònic. A més, no som responsables de cap obstrucció de la configuració de privadesa ni de les mesures de seguretat del servei ni de la configuració de seguretat o les mesures de seguretat de llocs web de tercers. Conservarem la vostra informació personal el temps necessari per prestar-vos serveis o per altres finalitats comercials legítimes, com ara resoldre disputes, raons de seguretat i salut, o complir amb les nostres obligacions legals. La durada de la conservació de la informació personal dependrà de molts factors, com ara la quantitat, la natura, la sensibilitat de la informació, els riscos potencials d'ús no autoritzat o divulgació, els fins pels quals processem la informació i altres consideracions legalment vinculants.",
    block11:
      'Podem actualitzar aquesta Política de Privacitat de tant en tant. Quan ho fem, publicarem una versió actualitzada en aquesta pàgina, tret que la legislació aplicable ho exigeixi de manera diferent.',
    block12:
      "Si teniu alguna pregunta sense respondre o dubte sobre aquesta Política de Privadesa, poseu-vos en contacte amb el nostre servei d'atenció al client. Correu electrònic:",
    block2:
      'Recopilem la següent informació personal ("Informació Personal") relacionada amb vostè:',
    block3:
      'Informació proporcionada per vostè: Quan creeu un compte per utilitzar els nostres serveis o communicateu-vos amb nosaltres, recopilem informació personal de la manera següent:',
    block4:
      'Informació personal rebuda automàticament de l\'ús dels serveis: Quan accedeu, useu o interactueu amb els serveis, rebem la següent informació sobre el vostre accés, ús o interacció ("Informació tècnica"):',
    block5: 'Podem utilitzar informació personal per a les següents finalitats:',
    block6:
      "Resum o informació desidentificada: Podem agregar o desidentificar informació personal per prevenir la seva reutilització amb finalitats d'identificació i utilitzar aquesta informació per analitzar l'eficàcia dels nostres serveis, millorar i afegir funcions als nostres serveis, realitzar recerques i per a finalitats similars. A més, podem analitzar el comportament general i les característiques dels usuaris dels nostres serveis i compartir informació agregada amb tercers, publicar aquesta informació agregada o posar-la a disposició del públic en general. Podem recollir informació agregada mitjançant els serveis, mitjançant galetes i mitjançant altres mitjans descrits en aquesta Política de Privacitat. Mantenrem i utilitzarem la informació desidentificada en forma anònima o desidentificada, i no intentarem reidentificar aquesta informació excepte si ho demana la llei.",
    block7:
      'En determinats casos, podem proporcionar la vostra informació personal a tercers sense més avís previ, tret que la llei ho exigeixi:',
    block8:
      "Segons la vostra ubicació geogràfica, les persones de l'Espai Econòmic Europeu, el Regne Unit i el món sencer poden tenir determinats drets legals respecte a la seva informació personal. Per exemple, podeu tenir el dret a:",
    block9:
      'El servei pot contenir enllaços a altres llocs web que no són operats ni controlats per Noam, inclosos serveis de xarxes socials ("Llocs web de tercers"). La informació que comparteix amb els Llocs web de tercers estarà governada per les polítiques de privacitat específiques i els termes de servei dels Llocs web de tercers, no per aquesta Política de Privacitat. Proporcionem aquests enllaços per raons de comoditat i no impliquem el nostre endossament ni revisió d\'aquests llocs web. Poseu-vos en contacte directament amb els Llocs web de tercers per obtenir informació sobre les seves polítiques de privacitat i termes.',
    subBlock1:
      'Informació de l\'account: Quan creeu un compte a la nostra plataforma, recopilem informació relacionada amb el vostre compte, inclosos el vostre nom, informació de contacte, credencials de compte, informació de la targeta de pagament i història de transaccions ("Informació de l\'account").',
    subBlock10: 'Proporcionar, gestionar, mantenir i/o analitzar serveis;',
    subBlock11: 'Comunicant amb tu',
    subBlock12: 'Desenvolupar nous productes i serveis;',
    subBlock13:
      "Prevenir el frau, l'activitat criminal o el mal ús dels nostres serveis, i protegir la seguretat dels nostres sistemes informàtics, arquitectura i xarxes;",
    subBlock14: 'Realitzar transferències comercials;',
    subBlock15:
      'Complir amb les obligacions legals i els procediments legals, protegir els nostres drets, privadesa, seguretat o propietat, així com els de les nostres filials, vostè o altres tercers.',
    subBlock16:
      "Proveïdors i proveïdors de serveis: Per ajudar-nos a satisfer les necessitats operatives comercials i a realitzar determinats serveis i funcions, podem proporcionar informació personal a proveïdors i proveïdors de serveis, inclosos proveïdors de serveis d'hosting, proveïdors de serveis en núvol i altres proveïdors de serveis de tecnologia de la informació, programari de comunicació per correu electrònic i proveïdors de serveis d'anàlitica web, etc. Aquests socis només accediràn, processaran o emmagatzemaran informació personal sota les nostres instruccions mentre realitzin les seves tasques per a nosaltres.",
    subBlock17:
      'Transferències comercials: Si participem en transaccions estratègiques, reestructuracions, fallides, adquisicions per fallida o si els serveis passen a un altre proveïdor (en conjunt, "Transaccions"), les vostres dades personals i altres informacions poden ser compartides amb les parts transaccionals i altres parts que assisteixen en les Transaccions durant la diligència debida i transferides com a part de les Transaccions, juntament amb altres actius, a una companyia successor o afiliada.',
    subBlock18:
      "Exigències legals: Potser compartirem la vostra informació personal amb autoritats governamentals, companys de l'industria o altres tercers, inclosa la informació de les vostres interaccions amb els nostres serveis, (1) si ho exigeix la llei o si creiem que aquesta acció és necessària per complir amb obligacions legals; (2) per protegir i defensar els nostres drets o béns; (3) si determinem unilateralment que hi ha una violació dels nostres termes, polítiques o lleis; (4) per detectar o prevenir frau o altres activitats il·legals; (5) per protegir els nostres productes, empleats o usuaris, o la seguretat pública, la seguretat, la integritat; o (vi) per defensar-nos contra responsabilitat legal.",
    subBlock19: "Accedeix a la vostra informació personal i a la informació sobre com s'processa.",
    subBlock2:
      'Quan utilitzeu els nostres serveis, recopilem informació personal de les vostres entrades, càrregues de fitxers o comentaris que ens proveieu («Contingut»).',
    subBlock20: "Sol·liciteu l'eliminació de la vostra informació personal dels nostres registres.",
    subBlock21: 'Corregiu o actualitzeu la vostra informació personal.',
    subBlock22: 'Transferir la vostra informació personal a un tercer (portabilitat de dades).',
    subBlock23: 'Limita com processem les vostres dades personals.',
    subBlock24:
      'Retreu el vostre consentiment: quan em fem servir el consentiment com a base legal per al processament, podeu retirar el vostre consentiment en qualsevol moment.',
    subBlock25: 'Objeteu la manera com processem les vostres dades personals.',
    subBlock26: 'Millorant els nostres serveis i realitzant recerca;',
    subBlock3:
      'Informació de comunicació: Si ens envieu missatges, recollirem el vostre nom, dades de contacte i el contingut dels vostres missatges ("Informació de comunicació").',
    subBlock4:
      'Informació de les xarxes socials: Tenim pàgines en llocs web de xarxes socials com Instagram, Facebook, Medium, Twitter, YouTube i LinkedIn. Quan interactueu amb les nostres pàgines de xarxes socials, recopilem la informació personal que trieu proporcionar-nos, com ara les vostres dades de contacte ("Informació social"). A més, les empreses que allotgen les nostres pàgines de xarxes socials poden proporcionar-nos informació agregada i anàlisi sobre les nostres activitats a les xarxes socials.',
    subBlock5:
      "Dades de registre: Informació enviada automàticament pel vostre navegador quan useu els nostres serveis. Les dades de registre inclouen la vostra adreça de Protocol Internet (IP), el tipus i la configuració del navegador, la data i l'hora de les vostres sol·licituds, i com interactueu amb el nostre lloc web.",
    subBlock6:
      "Dades d'ús: Potser recopilem automàticament informació sobre l'ús que feu del servei, com ara els tipus de contingut que visualitzeu o amb què interactueu, les funcions que useu, les accions que realitzeu, així com la vostra zona horària, país, data i hora d'accés, agent d'usuari i versió, tipus d'ordinador o dispositiu mòbil i la vostra connexió a l'ordinador.",
    subBlock7:
      "Informació del dispositiu: Aquesta inclou el nom del dispositiu, el sistema operatiu, l'identificador del dispositiu i el navegador que esteu utilitzant. La informació recollida pot dependre del tipus de dispositiu que esteu utilitzant i de les seves configuracions.",
    subBlock8:
      'Galetes: Fem servir galetes per operar i gestionar els nostres serveis i millorar la vostra experiència. Una "galeta" és informació que envia un lloc web que visiteu al vostre navegador. Podeu configurar el navegador per acceptar totes les galetes, rebutjar totes les galetes o notificar-vos quan s\'ofereixi una galeta per decidir si l\'acceptau cada vegada. No obstant això, rebutjar les galetes pot impedir-vos utilitzar o afectar negativament la visualització o la funcionalitat de determinades àrees o funcions del lloc web. Per obtenir més informació sobre les galetes, visiteu All About Cookies.',
    subBlock9:
      "Analytics: Podem utilitzar diversos productes d'anàlitics en línia que fan servir galetes per ajudar-nos a analitzar com els usuaris utilitzen els nostres serveis i millorar la vostra experiència en utilitzar els serveis.",
    subTitle1: 'Informació personal que recopilem',
    subTitle2: 'Com utilitzem la informació personal',
    subTitle3: 'Divulgació de Dades Personals',
    subTitle4: 'Els vostres drets',
    subTitle5: 'Enllaços a altres llocs web',
    subTitle6: 'Seguretat i Conservació de la Informació',
    subTitle7: 'Modificació de la política de privadesa',
    subTitle8: 'Com contactar-nos',
    title: 'Política de Privadesa',
    updateTime: 'Actualitzat: 15 de març de 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Acceptar-ho tot',
    text: 'Per millorar la vostra experiència, utilitzem galetes per personalitzar continguts i serveis.',
    title: 'Aquest lloc web utilitza galetes',
  },
  slogen: "L'assistent d'AI més fàcil",
  stripe: {
    contact: 'Poseu-nos qualsevol pregunta a contact@noam.tools!',
    fail: {
      btn: 'Torna a provar',
      text1: 'No hem pogut processar el seu pagament.',
      text2: 'Comprova la teva connexió i torna a provar-ho.',
      title: 'El pagament ha fallat',
    },
    succ: { btn: 'Anem', text1: 'Benvingut/da a Noam', text2: 'comencem!', title: 'Felicitacions' },
  },
  terms: {
    block1: 'Gràcies per utilitzar Noam!',
    block10:
      '(a) Tarifes i facturació. Pagaràs totes les tarifes ("Tarifes") segons els preus i condicions de la pàgina de preus corresponent o segons acorden escritament entre nosaltres. Ens reservem el dret de corregir errors de preu o equívocs, fins i tot si hem emès factures o rebut el pagament. Proporcionaràs informació de facturació completa i exacta, inclosos un mètode de pagament vàlid i autoritzat. Cobrarem el seu mètode de pagament periòdicament segons acordem, però podem canviar la data de facturació de manera raonable. Autoritzes a Noam, a les seves afiliades i a els processadors de pagaments de tercers a cobrar al seu mètode de pagament. Si el seu pagament falla, us enviarem un avís escrit i podem suspendre l\'accés al Servei fins que es rebi el pagament. Excepte que s\'especifiqui el contrari en aquest acord, els pagaments no són reembolsables.',
    block11:
      '(b) Impostos. Salvo que s\'indiqui el contrari, les tarifes no inclouen cap impost, dret o avaluació similar federal, estatal, local o estranger ("Impostos"). Ets responsable de tots els Impostos associats a les teves compres, excepte els Impostos basats en el nostre ingressos nets, pels quals t\'emitirem una factura. Et compromets a pagar prontament aquests Impostos, a proporcionar-nos declaracions de privadesa legalment vàlides i a obtenir els consensos necessaris per a tractar aquests dades, i ens garanteixes que tractes aquestes dades segons la legislació aplicable.',
    block12:
      "(c) Canvis de preu. Podem canviar els nostres preus notificant-vos mitjançant el vostre compte i/o el nostre lloc web. Les augmentacions de preu entraran en vigor immediatament després de la publicació. Qualsevol canvi de preu s'aplicarà a les Tarifes del vostre compte després de la data d'entrada en vigor del canvi.",
    block13:
      '(d) Disputes i pagaments en endarreriment. Si desitge contestar qualsevol Tarifa o Impost, si us plau, contacti amb contact@noam.tools en els trenta (30) dies següents a la data de la factura.',
    block14:
      '(e) Ús gratuït. No podeu crear múltiples comptes per obtenir crèdits gratuïts. Si determinem que no esteu utilitzant els crèdits gratuïts de bona fe, podem cobrar-vos les tarifes estàndard o deixar de proporcionar-vos accés al servei.',
    block15:
      "Confidencialitat. Podeu accedir a informació confidencial de Noam. Només podeu utilitzar la informació confidencial tal com permeten aquests termes i amb la finalitat d'utilitzar el Servei. No podeu revelar informació confidencial a cap tercer, i protegiràs la informació confidencial d'una manera no menys protectora que la que utilitzeu per protegir la vostra pròpia informació confidencial similar, almenys amb raonable cura. La informació confidencial és informació no pública designada com a confidencial per Noam o que raonablement s'ha de tractar com a confidencial en les circumstàncies, inclosos programari, especificacions i altra informació comercial no pública. La informació confidencial no inclou la informació que: (1) generalment estigui accessible al públic sense que sigui culpa vostra; (2) ja teniu en posesió sense cap obligació de confidencialitat abans de rebre-la segons aquests termes; (3) us sigui revelada legalment per un tercer sense cap obligació de confidencialitat; o (4) hàgiu desenvolupat de forma independent sense utilitzar la informació confidencial. Podeu revelar informació confidencial si ho demana la llei, un tribunal o qualsevol altra ordre governamental, però heu de donar notícia escrita prèvia a Noam de manera raonable i, en la mesura possible, fer esforços raonables per limitar l'abast de la revelació, inclosos ajudar-nos a oposar-nos a les sol·licituds de revelació.",
    block16:
      "(b) Seguretat. Heu d'implementar mesures raonables i adequades per ajudar a protegir l'accés i l'ús del Servei. Si descobreix alguna vulnerabilitat o violació relacionada amb l'ús del Servei, heu de contactar immediatament amb Noam i proporcionar detalls de la vulnerabilitat o violació.",
    block17:
      "(c) Processament de dades personals. Si utilitzeu el servei per processar dades personals, heu de proporcionar declaracions de privadesa legalment suficients i obtenir els consentiments necessaris per al processament d'aquestes dades, i ens garanteu que manegeu aquestes dades d'acord amb la legislació aplicable.",
    block18:
      "Finalització; Suspensió. Aquests termes entraràn en vigor a partir de la vostra primera utilització del Servei i romandran en vigor fins a la seva finalització. Podeu finalitzar aquests termes en qualsevol moment i per qualsevol motiu deixant d'utilitzar el Servei i el Contingut. Nosaltres podem finalitzar aquests termes amb previ avís per qualsevol motiu. Podem finalitzar immediatament aquests termes notificant-vos si violeu materialment la Secció 2 (Requisits d'ús), la Secció 5 (Confidencialitat, Seguretat i Protecció de Dades), la Secció 8 (Resolució de Controvèrsies) o la Secció 9 (Termes Generals), o si canvia la nostra relació amb qualsevol proveïdor de tecnologia de tercers fora del nostre control, o per compliment amb la llei o sol·licituds governamentals. Podem suspendre l'accés al Servei si no compleiu aquests termes, o si la vostra utilització suposa un risc de seguretat per a nosaltres o qualsevol tercer, o si sospitem que la vostra utilització és fraudulenta o pot exposar-nos a nosaltres o a qualsevol tercer a responsabilitat.",
    block19:
      "(b) Efectes de la rescissió. En cas de rescissió, deixaràs d'utilitzar el Servei i retornaràs o destruiràs prontament qualsevol informació confidencial segons nosaltres indiquem. Les disposicions d'aquestes condicions que per la seva naturalesa hagin de subsistir després de la rescissió o caducitat, inclosos, entre d'altres, els apartats 3 i 5-9, subsistiran.",
    block2:
      "Aquestos Termes d'ús s'apliquen a l'ús que feu dels serveis de Noam, inclosos els nostres interfícies de programació d'aplicacions, programari, eines, serveis per a desenvolupadors, dades, documentació i lloc web (referenciats col·lectivament com a \"Serveis\"). En fer servir els nostres Serveis, accepteu complir aquests termes. La nostra Política de Privacitat explica com recopilem i fem servir la informació personal.",
    block20:
      "Indemnització. Defendreu, indemnitzareu i mantindreunos a nosaltres, a les nostres filials i al nostre personal exents de qualsevol reclama, pèrdua i despesa (inclosos els honoraris legals) que derivi o estigui relacionat amb l'ús que feu del Servei, inclosos el vostre Contingut, l'ús que feu de productes o serveis relacionats amb el Servei, i la vostra violació d'aquestes condicions o la llei aplicable.",
    block21:
      "(b) Exclusions de responsabilitat. El servei s'ofereix \"tal com és\". En la mesura permesa per la llei, nosaltres, les nostres afiliades i els llicenciadors no fem cap representació ni garantia de cap tipus pel que fa al servei i no oferim cap garantia, incloses però no limitades a garanties de comerciabilitat, adequació per a un propòsit particular, qualitat satisfactòria, no infracció i gaudi tranquil, així com qualsevol garantia que sorgis del curs de les relacions comercials o de l'ús comercial. No garantim que el servei sigui ininterromput, exacte o lliure d'errors, ni que cap contingut sigui segur, no es perdi ni no es modifiqui.",
    block22:
      "(c) Limitació de responsabilitat. Ni nosaltres, les nostres afiliades, ni els nostres licenciadors seran responsables de cap dany indirecte, incidental, especial, conseqüent o punitiu, inclosos la pèrdua de beneficis, la pèrdua de reputació, la pèrdua d'ús, la pèrdua de dades o altres pèrdues intangibles, fins i tot si hem estat avisats de la possibilitat d'aquests danys. Segons aquests termes, la nostra responsabilitat total no excedirà les Tarifes que heu pagat al Servei als dotze (12) mesos precedents a la reclamació o cent dòlars nord-americans ($100), la que sigui major. Les limitacions d'aquesta secció s'apliquen en la mesura màxima permesa per la legislació aplicable.",
    block23:
      "Els Termes i l'ús que facis dels Serveis estan governats per les lleis dels Estats Units, excepte les regles nord-americanes de conflicte de lleis. L'ús de l'Aplicació també pot estar subjecte a altres lleis locals, estatal, nacionals o internacionals. Qualsevol acció o procediment legal relacionat amb aquests Termes s'presentarà exclusivament als tribunals dels Estats Units, i accepteu sotmetre-vos a la jurisdicció personal d'aquests tribunals.",
    block24:
      "Relació entre les parts. Noam i vostè sou contractistes independents, i cap de les parts té facultats per representar o obligar a l'altra part ni a assumir obligacions en nom de l'altra part sense el consentiment escrit previ de l'altra part.",
    block25:
      '(b) Ús de la marca. No podeu utilitzar el nom, els logotips ni les marques comercials de Noam ni de cap dels seus afiliats sense el nostre consentiment escrit previ.',
    block26:
      "Si alguna disposició d'aquestes condicions es determina com a invàlida, il·legal o inaplicable, les disposicions restants romandran en total vigor i efectivitat.",
    block3:
      "Si sou menor de 18 anys, heu d'obtenir el permís dels vostres pares o tutors legals per utilitzar el servei. Si utilitzeu el servei en nom d'una altra persona o entitat, heu d'estar autoritzat per acceptar aquests termes en seu nom. Heu de proporcionar informació exacta i completa per registrar-vos un compte. No podeu proporcionar les vostres credencials d'accés ni el compte a ningú fora de la vostra organització, i sou responsable de totes les activitats realitzades mitjançant les vostres credencials.",
    block4:
      '(a) Ús del servei. Podeu accedir al servei segons aquests termes, i us donem un dret no exclusiu a utilitzar el servei. Quan useu el servei, complireu aquests termes i totes les lleis aplicables. Nosaltres i les nostres afiliades posseeïm tots els drets, títols i interessos sobre el servei.',
    block5:
      "(b) Comentaris. Us donem la benvinguda a comentaris, opinions, idees, suggeriments i millores. Si proporcioneu qualsevol contingut d'aquest tipus, podem utilitzar-lo sense cap restricció i sense cap compensació per a vosaltres.",
    block6:
      "(c) Restriccions. No podeu: (1) utilitzar el Servei d'una manera que infrageixi, apropie o violi qualsevol dret d'altres persones; (2) realitzar ingenieria inversa, descompilar, desacoblar, traduir o intentar de qualsevol altra manera descobrir el codi font o components subjacents dels models, algoritmes i sistemes del Servei (excepte si aquestes restriccions estan prohibit per la legislació aplicable); (3) utilitzar la sortida del Servei per desenvolupar models que competeixin amb Noam; (4) extreure dades o sortida del Servei mitjançant qualsevol mètode automatitzat o de programació, tret que estigui permès mitjançant l'API, inclosos el scraping, la recollida web o l'extracció de dades web; (5) representar la sortida del Servei com a generada artificialment quan no ho és, o violar de qualsevol altra manera les nostres polítiques d'ús; (6) comprar, vendre o transferir claus API sense el nostre consentiment previ; o (7) proporcionar-nos qualsevol informació personal de nens menors de 13 anys o l'edat applicable de consentiment digital. Complireu amb qualsevol límit de velocitat i altres requisits de la nostra documentació.",
    block7:
      '(d) Serveis de tercers. Qualsevol programari, servei o altre producte de tercers associat al Servei està regit per les seves pròpies condicions, i no som responsables dels productes de tercers.',
    block8:
      'El vostre contingut. Podeu proporcionar entrada ("Entrada") al Servei i rebre sortida ("Sortida") generada i retornada a partir de l\'Entrada (en conjunt anomenats "Contingut"). Entre les parts, i en la mesura permesa per la legislació aplicable, sou propietari de tota l\'Entrada. Noam pot utilitzar el Contingut per proporcionar i mantenir el Servei, complir amb la legislació aplicable i fer complir les nostres polítiques. Sou responsable del Contingut, inclosos garantir que no viola cap legislació aplicable ni aquests termes.',
    block9:
      "(b) Precisió. L'inteligència artificial i l'aprenentatge automàtic són camps de recerca en ràpida evolució. Ens empenyem contínuament per millorar el nostre servei i fer-lo més precís, fiable, segur i beneficiós. Atès la naturalesa probabilística de l'aprenentatge automàtic, l'ús del nostre servei pot donar lloc a resultats incorrectes en determinats casos, que poden no reflectir amb precisió persones reals, llocs o fets. Hauríeu d'avaluar adequadament la precisió de qualsevol resultat segons el vostre cas d'ús, incloent revisant manualment els resultats.",
    subTitle1: 'Registració i Accés',
    subTitle10: 'Divisibilitat',
    subTitle2: "Requisits d'ús",
    subTitle3: 'Contingut',
    subTitle4: 'Tarifes i pagament',
    subTitle5: 'Confidencialitat, Seguretat i Protecció de Dades',
    subTitle6: 'Termini i rescissió',
    subTitle7: 'Indemnització; Exclusions de responsabilitat; Limitació de responsabilitat',
    subTitle8: 'Llei aplicable i jurisdicció',
    subTitle9: 'Termes generals',
    title: "Condicions d'ús",
    updateTime: 'Actualitzat: 15 de març de 2024',
  },
  trialModal: {
    btn: 'Comença ara (només 0,99 $)',
    chat: 'ChatPDF',
    desc1: 'Després de la teva prova, se t cobrarà una quota anual de 180 dòlars',
    desc2: 'Cancel·la en qualsevol moment',
    focus: 'Centrant-se',
    hover: 'Traducció flotant',
    image: "Traducció d'imatges",
    installBtn: 'Instal·la ara per rebre el teu regal',
    memo: "Gestió d'estats favorits",
    pdf: 'Traducció paral·lela PDF',
    realtime: 'Traducció instantànea',
    select: 'Traducció de selecció de paraules',
    title: 'Regal de benvinguda',
    trialText: 'Prova de 7 dies',
    video: 'Traducció de vídeo',
    videoSummary: 'Resum de vídeo',
    web: 'Traducció paral·lela',
    webSummary: 'Resum web',
  },
  upgradeModal: {
    btn: 'Actualitza ara',
    chat: {
      free: 'Has arribat al límit de ChatPDF',
      pro: 'Has arribat al límit de ChatPDF per aquest mes',
    },
    contactStr:
      'Espereu el següent reinici o poseu-vos en contacte amb nosaltres a contact@noam.tools.',
    limitAlertStr: 'Has arribat al límit del teu pla gratuït. Actualitza per continuar.',
    more: 'Veure Plans',
    pageLimit: { free: 'Heu arribat al límit de pàgines PDF' },
    title: 'Recordatori',
    upgradeAlertStr: 'Has arribat al límit del pla gratuït. Actualitza per continuar.',
    upload: {
      free: 'Has arribat al límit de traducció de PDF',
      pro: 'Has arribat al límit de traduccions PDF per aquest mes',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Uneix-te ara',
      label: 'Beneficis per a nous usuaris:',
      remain: 'Només en queden 30',
      text: 'Només 100 places disponibles! Aprofita la teva ara mateix!',
    },
  },
  aiPdfTranslator: {
    title: "Traductor PDF d'AI gratuït: Traduïu PDF amb comparació en qualsevol idioma",
    desc: 'Traduïu fàcilment fitxers PDF a qualsevol idioma amb IA. Compara el text original i el traduït costat a costat, ràpidament i gratuïtament.',
    keywords: "GPT-4、Assistent d'IA、Traducció、Resum、Focus、ChatPDF、Memorandi、eficiència",
    sourceToTarget: {
      title:
        'Eina gratuïta de traducció de PDF: tradueix {{source}} a {{target}} de forma gratuïta',
      desc: 'Traduïu els vostres fitxers PDF des de qualsevol idioma font cap al vostre idioma preferit de forma gratuïta. Traducció de PDF ràpida, precisa i segura impulsada per IA avançada.',
    },
    headerIntroduce: {
      title: 'Noam: Més que una simple traducció en línia',
      introduce1: {
        title: 'Noam · Lector PDF',
        desc: '✨Traducció en paral·lel + Q&A amb IA. Traduïu PDF ràpidament i amb precisió a la vostra llengua objectiu. Feu preguntes lliurement sobre el contingut per aconseguir una comprensió més profunda dels vostres fitxers PDF.',
      },
      introduce2: {
        title: 'Noam · Extensió de Traducció en Paral·lel',
        desc: '👏Resoleu totes les vostres necessitats de traducció de pàgines web:',
        detail1: { title: 'Traducció de pàgina web:', desc: 'Vista bilingüe en paral·lel' },
        detail2: { title: 'Traducció de paraules:', desc: 'Traducció ràpida amb un clic' },
        detail3: {
          title: 'Traducció instantània:',
          desc: 'Traduïu paraules o frases instantàniament.',
        },
        detail4: {
          title: "Traducció d'imatge:",
          desc: 'Reemplaceu les imatges per les traduïdes.',
        },
        detail5: {
          title: 'Traducció de vídeo:',
          desc: 'Subtítols bilingües per a una visualització millor.',
        },
        footer:
          'Disfruteu de més funcions de lectura impulsades per IA per a una traducció més intel·ligent!',
      },
    },
    subtitle: 'Traductor PDF en línia gratuït',
    introduce: {
      module1: {
        detail1: {
          title: 'Traducció PDF en temps real side-by-side',
          desc1:
            'Mostra instantàniament el contingut original i traduït en un disseny sincronitzat i en paral·lel',
          desc2: 'Compareu amb facilitat ambdues versions amb desplaçament sincronitzat',
          desc3: 'Mantenir el format idèntic per a una experiència de lectura consistent',
        },
        detail2: {
          title: 'Alineació i Verificació Precisa de Contingut',
          desc1: 'Alineació perfecta entre el text font i el traduït per a una verificació fàcil',
          desc2: 'Cada segment de contingut coincideix exactament entre ambdues versions',
          desc3:
            'Detecteu i resoluïu ràpidament les discrepàncies de traducció per obtenir resultats fiables',
        },
      },
      module2: {
        detail1: {
          title: "Múltiples models avançats d'IA per a una traducció precisa",
          desc1:
            "Seleccioneu entre els principals models d'IA per adaptar-vos a les vostres necessitats de traducció",
          desc2: 'Assegurar resultats òptims per a diversos tipus de documents i indústries',
          desc3: 'Les opcions de model flexibles ofereixen solucions adaptades a cada escenari',
        },
        detail2: {
          title: "Traducció avançada d'IA per a qualsevol tipus de contingut",
          desc1:
            "El nostre potent model d'IA garanteix una alta precisió i una comprensió natural del llenguatge",
          desc2: 'Gestiona documents tècnics, acadèmics i creatius amb facilitat',
          desc3: 'Ofereix resultats fiables per a totes les vostres necessitats de traducció',
          desc4: 'Adaptació intel·ligent a diferents tipus de contingut per a un rendiment òptim',
        },
      },
      module3: {
        detail1: {
          title: 'Interacció Intel·ligent amb Documents',
          desc1:
            'Xateja sense esforç amb els teus fitxers PDF i presentacions mitjançant IA avançada',
          desc2:
            'Fes preguntes instantànies sobre el contingut del document i rep respostes precises',
          desc3: 'Genera resums concisos ràpidament per a documents llargs',
        },
        detail2: {
          title: 'Anàlisi Profunda de Contingut i Integració Senzilla',
          desc1:
            'Extreu informació clau i analitza dades complexes amb comprensió impulsada per IA',
          desc2: 'Obté coneixements profunds sobre materials tècnics, acadèmics o creatius',
          desc3:
            "S'integra de manera fluida amb el nostre Traductor PDF per oferir una solució completa de gestió de documents",
        },
      },
      module4: {
        detail1: {
          title: 'Més enllà de la traducció de PDF: Solució integral de traducció de pàgines web',
          desc: 'Descobreix la nostra potent extensió de traducció en paral·lel dissenyada per a qualsevol escenari de lectura en línia.',
          desc1:
            'Traducció de pàgines web: Gaudiu de contingut bilingüe amb una visualització sincronitzada costat a costat',
          desc2:
            'Traducció de paraules: Traduïu instantàniament les paraules ressaltades amb un sol clic',
          desc3:
            'Traducció instantània: Traduïu qualsevol text o frase al moment per a una comprensió ràpida',
          desc4:
            "Traducció d'imatges: Substituï automàticament les imatges originals per versions traduïdes",
          desc5:
            'Traducció de Vídeos: Visualitza vídeos amb subtítols bilingües per a una experiència millorada',
        },
      },
    },
    question: {
      title: 'Preguntes Freqüents',
      answer1: {
        title: 'És gratuït utilitzar Noam PDF Translator per a la traducció de PDF?',
        content:
          'Sí, pots traduir PDFs de forma gratuïta amb Sider PDF Translator! Ofereix un quòtum gratuït de 5.000 tokens, el qual és suficient per traduir la majoria de documents PDF habituals al mercat. Si necessites traduir fitxers més grans o requereixes funcions avançades, pots optar per actualitzar a nuestros plans premium per aconseguir encara més capacitats.',
      },
      answer2: {
        title: 'Quina precisió té el traductor PDF de Noam?',
        content:
          "El Noam PDF Translator ofereix traduccions altament precises mitjançant l'ús de tecnologia AI avançada i entenent profundament el context dels vostres documents. Tot i que cap traducció automàtica és perfecta, la nostra visualització en paral·lel us permet revisar i millorar fàcilment cada traducció, garantint que el resultat final compleixi les vostres expectatives de qualitat. Experimenteu una traducció de PDF fiable i precisa amb Noam.",
      },
      answer3: {
        title: 'Puc traduir PDFs escanejats?',
        content:
          "Sí, podeu traduir PDFs escanejats amb la nostra tecnologia OCR (Reconèixer Caràcters Òptics) integrada. El nostre sistema extreu automàticament el text de documents escanejats i PDFs basats en imatges, i després tradueix el contingut per a vosaltres. Això garanteix que fins i tot els PDFs no editables o només d'imatge es puguin traduir amb precisió.",
      },
      answer4: {
        title: 'Quan tarda la traducció?',
        content:
          'La traducció és ràpida i eficient: la majoria de documents es processen en segons o uns minuts, depenent de la seva longitud i complexitat. Per exemple, un PDF estàndard de 10 pàgines sol trigar menys de 2 minuts a traduir. Gaudeix de temps de resposta ràpids per a totes les vostres necessitats de traducció de documents!',
      },
      answer5: {
        title: 'Puc mantenir la vista en paral·lel per a llegir?',
        content:
          "Sí, sempre pots llegir els teus documents de banda a banda. Aquest disseny t'permite comparar fàcilment el contingut original i el traduït, garantint una experiència de lectura fluida i eficient.",
      },
    },
    freeTrial: 'Prova gratuïta',
    toLanguage: { title: 'Parells de Traducció AI PDF', item: '{{target}}' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'Blog',
      button: 'Traduir ara',
      features: 'Funcionalitats',
      pricing: 'Preus',
      faq: 'Preguntes freqüents',
    },
    hero: {
      upload: {
        title: 'Carrega el teu PDF',
        max: 'Max',
        highlight: 'Feu clic per navegar',
        desc: 'o arrossega i deixa anar',
      },
      to: 'a',
      title: 'Traductor gratuït de PDF',
      pill: 'Traductor de PDF impulsat per IA',
      desc: 'Traduccions instantànies i precises que conserven el disseny original. Noam AI admet OCR i vistes side-by-side.',
      support: 'Suport OCR',
      model: 'GPT-4 i Claude',
      free: 'Prova gratuita',
      translated: 'Traduit per Noam',
      complete: 'Traducció completada',
    },
    ticker: {
      pdf: 'Traducció de PDF',
      ocr: 'Tecnologia OCR',
      format: 'Conservació de Format',
      multi: 'Multiidioma',
      chat: 'Xat amb PDF',
      side: 'Junt a Junt',
      web: 'Traducció web',
      secure: 'Segur i Privat',
    },
    comparison: {
      bad: {
        title: 'Traducció estàndard',
        head: 'Format i context perduts',
        text1: 'Error: Disseny trencat. Imatges mal posicionades.',
        text2:
          'El text es superposa i les fonts no són consistents. Difícil de llegir i no professional...',
      },
      dump: { title: 'Volcat de text pla' },
      good: {
        title: 'Traducció Noam AI',
        sub: 'Formatació Perfecta, Conscient del Context',
        tag: 'Resultat perfecte',
      },
      title: 'Per què triar Noam AI?',
      desc: 'Deixa de lluitar amb la traducció per copiar i enganxar. Experimenta la diferència entre les eines estàndard i la nostra traducció amb IA conscienciosa del context.',
    },
    showcase: {
      title2: 'Qualsevol idioma',
      title1: 'Qualsevol Document',
      kicker: 'DOCUMENTS ADMESOS',
      carousel1: 'Art',
      note: 'Manega documents tècnics, acadèmics i creatius amb facilitat.',
      carousel3: 'Revista acadèmica',
      carousel4: 'Medicina',
      carousel5: 'Finances',
      carousel2: 'Arquitectura',
      carousel6: 'Dret',
      carousel8: 'Política',
      carousel7: 'Contracte',
    },
    features: {
      big: {
        title: "Models d'IA avançats (GPT-4, Claude)",
        desc: "Seleccioneu entre els principals models d'IA per adaptar-vos a les vostres necessitats de traducció. Assegureu-vos resultats òptims per a diversos tipus de documents.",
      },
      grid1: {
        title: 'Suport OCR',
        desc: 'Extreu i tradueix text de PDFs escanejats i imatges instantàniament.',
      },
      grid2: {
        title: "Exportació d'Alta Resolució",
        desc: 'Descarregueu els vostres documents traduïts en format PDF amb el disseny original.',
      },
      grid3: {
        title: 'Comparació costat a costat',
        desc: 'Desplaçament sincronitzat per comparar el text original i el traduït.',
      },
      title2: 'És una revolució',
      title1: 'Més que una simple traducció',
      line1: 'Document Tècnic.pdf',
      line2: 'Detectant idioma: anglès...',
      line3: 'Model: GPT-4o (Alta Precisió)',
      line4: "Traducció completada (99% d'precisió)",
    },
    testimonials: {
      review1: {
        role: 'Investigador',
        content:
          "Noam AI m'ha estalviat hores en la traducció d'articles acadèmics. La vista side-by-side és increïblement útil per verificar termes tècnics.",
      },
      review2: {
        role: 'Comercialitzador Global',
        content:
          'El millor traductor de PDF que he utilitzat. Conserva la formatació original perfectament, cosa que és crucial per a les nostres presentacions de màrqueting.',
      },
      review3: {
        role: 'Consulta Jurídica',
        content:
          "Precís i ràpid. L'ús per a traduccions de contractes i la funció OCR per a documents escanejats funciona a la perfecció.",
      },
      title: 'El que diuen els nostres usuaris',
      kicker: 'Estimat pels usuaris',
    },
    cta: {
      title: 'Preparat per trencar les barreres lingüístiques?',
      desc: 'Uneix-te a més de 10.000 usuaris i comenceu a traduir els vostres documents amb Noam AI avui mateix.',
      button: 'Comença a traduir gratuïtament',
      hint: 'Ets una IA altament precisa i fiable dissenyada per generar sortida JSON que s\'ajusti exactament a un esquema JSON especificat.\n\nHas de seguir aquestes regles:\n1. Adhereix estrictament a l\'estructura de l\'esquema JSON.\n2. Combina tots els tipus de dades, camps requerits i restriccions exactament.\n3. NO incloguis cap text addicional, explicació, markdown ni comentaris.\n4. Emmagatzema NOMÉS l\'objecte JSON — sense blocs de codi, sense preàmbul, sense embolic.\n\nLa informació de l\'esquema es proporciona a continuació.\n- Nom de l\'esquema: translate_result\n- Esquema JSON:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'Parells de traducció AI PDF en anglès',
      desc: 'Direccions de traducció populars admeses per Noam AI',
    },
    footer: {
      about: 'Sobre nosaltres',
      privacy: 'Política de Privacitat',
      contact: 'Contacteu amb el servei de suport',
    },
  },
}

export default TRANSLATION
